import { render, staticRenderFns } from "./CardDatesDetail.vue?vue&type=template&id=29dd612b"
import script from "./CardDatesDetail.vue?vue&type=script&lang=js"
export * from "./CardDatesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports